import { IconWrapper } from '@/components/shared/IconWrapper';
import { cardBrandLabel } from './card-brand-label';
import type { PaymentMethod } from '@/types/payment-method';
import { PaymentMethodType } from '@/types/payment-method';
import { HStack, Text } from '@chakra-ui/react';
import { CreditCard, GraduationCap } from 'iconoir-react';

interface SelectedPaymentMethodDisplayProps {
  paymentMethod: PaymentMethod | undefined;
}

const formatPaymentMethodText = (pm: PaymentMethod): string => {
  if (pm.type === PaymentMethodType.Card && pm.brand && pm.last4) {
    const brandName = cardBrandLabel(pm.brand);
    // Use dots instead of "ending in"
    let baseText = `${brandName} •••• ${pm.last4}`;

    // Add expiration date if available
    if (pm.expMonth && pm.expYear) {
      const month = pm.expMonth.toString().padStart(2, '0');
      const year = pm.expYear.toString().slice(-2); // Get last two digits of the year
      baseText += ` (expires ${month}/${year})`;
    }

    return baseText;
  } else if (pm.type === PaymentMethodType.BankTransfer && pm.last4) {
    // Use dots instead of "ending in"
    return `Bank Transfer •••• ${pm.last4}`;
  }
  return 'Payment method'; // Fallback for unknown types or missing data
};

export const SelectedPaymentMethodDisplay: React.FC<SelectedPaymentMethodDisplayProps> = ({
  paymentMethod,
}) => {
  if (!paymentMethod) {
    return <Text fontSize="15px">No payment method selected</Text>;
  }

  const iconComponent = paymentMethod.type === PaymentMethodType.Card ? CreditCard : GraduationCap;
  const displayText = formatPaymentMethodText(paymentMethod);

  return (
    <HStack gap={2} align="center">
      <IconWrapper icon={iconComponent} boxSize={4} color="primary.focusRing" />
      <Text fontSize="15px">{displayText}</Text>
    </HStack>
  );
};
